import dayjs from "dayjs";

export const renderDate = (date?: string | null) => {
  if (!date) return "";

  return dayjs.utc(date).format("l");
};

export const renderDateTime = (date?: string | null) => {
  if (!date) return "";

  return dayjs.utc(date).format("l LT");
};

export const renderTime = (date?: string | null) => {
  if (!date) return "";

  return dayjs.utc(date).format("LT");
};
